import { jsx as _jsx } from "react/jsx-runtime";
import { CardTitle } from '@coolblue-development/freddy';
import { EntranceDisplay } from '../../../../types.js';
const EntranceCardTitle = ({ displayStyle, children, }) => (_jsx(CardTitle, { component: "h3", textAlign: displayStyle === EntranceDisplay.WithDescription ||
        displayStyle === EntranceDisplay.WithProCon
        ? 'left'
        : 'center', children: children }));
export default EntranceCardTitle;
//# sourceMappingURL=EntranceCardTitle.js.map